import CreateUser from './CreateUserContainer';

export default CreateUser;
